import _ from 'lodash'
import { createApp } from 'vue'
import axios from 'axios'


window._ = _;
window.axios = axios;


window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : 'AIbXSYFytXzM6A8syG5kfWjFDMs0ppOlq06Q8iEq',
}


import VotingApp from '../js/vue/VotingApp.vue'


const app = createApp({
    components: {
        VotingApp
    }
})

app.mount('#kvalita-je-v-nas')